import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'types/index';

import { initialState } from './slice';

const selectDomain = (state: RootState) =>
  state.vulnerabilityOverview || initialState;

export const selectVulnerabilityOverview = createSelector(
  [selectDomain],
  state => state,
);
